import { Injectable, Inject, Optional } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GungAnalyticsConsentService {
  private consentSubject: BehaviorSubject<boolean>;

  constructor(@Optional() @Inject('environment') private environment: any) {
    const isBannerRequired = this.environment?.enableCookies === true;
    const initialConsent = !isBannerRequired || localStorage.getItem('cookiesAccepted') === 'true';
    this.consentSubject = new BehaviorSubject<boolean>(initialConsent);
  }

  public isUserConsentingToAnalytics(): boolean {
    const isBannerRequired = this.environment?.enableCookies === true;
    if (!isBannerRequired) return true;
    return localStorage.getItem('cookiesAccepted') === 'true';
  }

  public getConsentObservable(): Observable<boolean> {
    return this.consentSubject.asObservable();
  }

  public setConsent(consented: boolean): void {
    localStorage.setItem('cookiesAccepted', consented ? 'true' : 'false');
    this.consentSubject.next(consented);
  }
}
